<template>
    <modal @close="$emit('close')">
        <template slot="header">
            Website -
            <template>add new</template>
        </template>
        <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
            <div class="form-group row">
                <label class="col-form-label col-lg-4">Website name</label>
                <div class="col-lg-8">
                    <input type="text" class="form-control" v-model="form.name" placeholder="Enter website name">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-4">Slug</label>
                <div class="col-lg-8">
                    <input type="text" class="form-control" v-model="form.slug" placeholder="website-slug" readonly>
                    <small class="form-text text-muted">Auto-generated from website name</small>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-4">Choose Vultr account</label>
                <div class="col-lg-8">
                    <multiselect v-model="form.vultr_account" tag-placeholder=""
                        placeholder="Search for a Vultr account" label="name" track-by="_id"
                        :options="vultr_accounts || []" :multiple="false">
                    </multiselect>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-4">Choose Domain</label>
                <div class="col-lg-8">
                    <multiselect v-model="form.domain" tag-placeholder="" @search-change="domainFind" :searchable="true"
                        :loading="loadingTypeahead" placeholder="Search for a domain" label="domain" track-by="domain"
                        :options="domain || []" :multiple="false">
                    </multiselect>
                </div>
            </div>
            <div class="alert alert-danger" v-if="err">{{ err }}</div>
            <div class="form-group row">
                <label class="col-form-label col-lg-12">
                    <button type="button" class="btn btn-primary" @click="save()" :disabled="!canSave">Save</button>
                    <button class="btn btn-link" @click="$emit('close')">Cancel</button>
                </label>
            </div>
        </fieldset>
    </modal>
</template>
<script>
import modal from '../common/Modal.vue'

let dbtm

export default {
    components: { modal },
    props: {
        id: {
            type: [String, Boolean],
            default: false
        }
    },
    data() {
        return {
            form: {
                name: '',
                slug: '',
                vultr_account: null,
                domain: null
            },
            err: null,
            loading: false,
            vultr_accounts: [],
            domain: [],
            loadingTypeahead: false
        }
    },
    computed: {
        canSave() {
            return this.form.name && this.form.name.trim().length > 0 &&
                this.form.vultr_account && this.form.domain
        }
    },
    methods: {
        async loadOptions() {
            this.loading = true
            try {
                // Load Vultr accounts
                let vultrResponse = await this.$api.getReq('accounts/vultr')
                this.vultr_accounts = vultrResponse.body.data || []
            } catch (e) {
                console.error('Error loading options:', e)
                this.err = 'Error loading form options'
            } finally {
                this.loading = false
            }
        },
        async save() {
            this.err = null
            this.loading = true

            try {
                let payload = {
                    name: this.form.name.trim(),
                    vultr_account: this.form.vultr_account._id,
                    domain: this.form.domain._id
                }

                await this.$api.postReq('website', payload)

                this.$emit('close')
                this.$emit('reload')
            } catch (e) {
                console.error(e)
                this.err = e.body && e.body.error ? e.body.error : 'Error saving website'
            } finally {
                this.loading = false
            }
        },
        generateSlug(name) {
            if (!name) return ''
            return name
                .toLowerCase()
                .replace(/[^a-z0-9\s-]/g, '') // Remove special characters except spaces and hyphens
                .replace(/\s+/g, '-') // Replace spaces with hyphens
                .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
                .replace(/^-|-$/g, '') // Remove leading/trailing hyphens
        },
        domainFind(query) {
            if (query === '') {
                return
            }
            this.domain = []

            this.loadingTypeahead = true
            clearTimeout(dbtm)
            dbtm = setTimeout(() => {
                this.$api.getReq('typeahead/domain?query=' + query).then(res => {
                    this.loadingTypeahead = false
                    res.body.data.domain.map(d => {
                        this.domain.push({
                            _id: d._id,
                            domain: d.domain
                        })
                    })
                })
            }, 500)
        }
    },
    watch: {
        'form.name'(newName) {
            this.form.slug = this.generateSlug(newName)
        }
    },
    async mounted() {
        await this.loadOptions()

        // Fill with test data when running on localhost
        if (document.location.href.indexOf('localhost') >= 0) {
            this.form.name = 'test website'
        }
    }
}
</script>
<style scoped>
.loading-mask {
    position: relative;
    pointer-events: none;
    opacity: 0.6;
}

.loading-mask::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/modal/Website.vue